"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapTransformDependencies = void 0;

var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");

var _factoriesAny = require("../../factoriesAny.js");

/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
var mapTransformDependencies = {
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createMapTransform: _factoriesAny.createMapTransform
};
exports.mapTransformDependencies = mapTransformDependencies;